export default "__VITE_ASSET__CJdDmz3u__"